(function ($) {
    "use strict";
    $(function () {
        const appendPageNumber = (index, pageCount, currentPage, paginationNumbers, listItems) => {
            const pageNumber = document.createElement("button");
            pageNumber.className = "pagination-number";
            pageNumber.innerHTML = index;
            pageNumber.setAttribute("page-index", index);
            pageNumber.setAttribute("aria-label", "Page " + index);

            paginationNumbers.appendChild(pageNumber);
        };

        const addArrows = (currentPage, pageCount, prev = true, paginationNumbers, listItems) => {
            const index = prev ? currentPage - 1 : currentPage + 1;
            const button = document.createElement("button");
            button.className = "pagination-number chevron";
            button.innerHTML = prev ? '<img alt="chevron-left" src="' + localize.themeurl + '/assets/img/svg/chevron/chevron-left.svg">' : '<img alt="chevron-left" src="' + localize.themeurl + '/assets/img/svg/chevron/chevron-right.svg">';

            if (prev) {
                button.classList.add("prev-button");
            } else {
                button.classList.add("next-button");
            }

            if (prev && currentPage === 1) {
                button.classList.add("disabled");
                button.setAttribute("disabled", true);
            }

            if (!prev && currentPage === pageCount) {
                button.classList.add("disabled");
                button.setAttribute("disabled", true);
            }

            $(button).on("click", function () {
                window.scrollTo({ top: $(listItems).parent().offset().top - 100, behavior: "smooth" });

                if (button.getAttribute("page-index")) {
                    const currentindex = parseInt(button.getAttribute("page-index"));
                    let num = prev ? currentindex - 1 : currentindex + 1;

                    const currentPageNumber = $(paginationNumbers).find(".prev-button").next();
                    currentPageNumber.text(num);

                    if (num <= pageCount && num > 0) {
                        setCurrentPage(num, pageCount, 3, listItems);
                        $(paginationNumbers).find(".prev-button").attr("page-index", num);
                        $(paginationNumbers).find(".next-button").attr("page-index", num);
                    }

                    if (num === 1) {
                        $(paginationNumbers).find(".prev-button").addClass("disabled");
                        $(paginationNumbers).find(".prev-button").attr("disabled", true);
                    } else {
                        $(paginationNumbers).find(".prev-button").removeClass("disabled");
                        $(paginationNumbers).find(".prev-button").attr("disabled", false);
                    }

                    if (num === pageCount) {
                        $(paginationNumbers).find(".next-button").addClass("disabled");
                        $(paginationNumbers).find(".next-button").attr("disabled", true);
                    } else {
                        $(paginationNumbers).find(".next-button").removeClass("disabled");
                        $(paginationNumbers).find(".next-button").attr("disabled", false);
                    }
                } else {
                    setCurrentPage(index, pageCount, 3, listItems);

                    button.setAttribute("page-index", index);
                    $(paginationNumbers).find(".prev-button").attr("page-index", 2);

                    const currentPageNumber = $(paginationNumbers).find(".prev-button").next();
                    currentPageNumber.text(index);

                    if (index === 1) {
                        $(paginationNumbers).find(".prev-button").addClass("disabled");
                        $(paginationNumbers).find(".prev-button").attr("disabled", true);
                    } else {
                        $(paginationNumbers).find(".prev-button").removeClass("disabled");
                        $(paginationNumbers).find(".prev-button").attr("disabled", false);
                    }

                    if (index === pageCount) {
                        $(paginationNumbers).find(".next-button").addClass("disabled");
                        $(paginationNumbers).find(".next-button").attr("disabled", true);
                    } else {
                        $(paginationNumbers).find(".next-button").removeClass("disabled");
                        $(paginationNumbers).find(".next-button").attr("disabled", false);
                    }
                }
            });

            paginationNumbers.appendChild(button);
        };

        const getMobilePagination = (pageCount, currentPage, paginationNumbers, listItems) => {
            paginationNumbers.innerHTML = "";
            addArrows(currentPage, pageCount, true, paginationNumbers, listItems);
            appendPageNumber(currentPage, pageCount, currentPage, paginationNumbers, listItems);
            const slash = document.createElement("span");
            slash.className = "pagination-slash";
            slash.innerHTML = "/";
            paginationNumbers.appendChild(slash);
            appendPageNumber(pageCount, pageCount, currentPage, paginationNumbers, listItems);
            addArrows(currentPage, pageCount, false, paginationNumbers, listItems);
        };

        const setCurrentPage = (pageNum, pageCount, paginationLimit, listItems) => {
            const prevRange = (pageNum - 1) * paginationLimit;
            const currRange = pageNum * paginationLimit;

            listItems.each(function (index) {
                const item = $(this);

                item.addClass("hidden");

                if (index >= prevRange && index < currRange) {
                    item.removeClass("hidden");
                }
            });
        };


        $.makeResidentialPager = function () {

            if ($(".js-residential-pager").length) {
                $(".js-residential-pager").each(function (index) {
                    const listItems = $(this).find(".swiper-slide");
                    const pageCount = Math.ceil(listItems.length / 3);
                    setCurrentPage(1, pageCount, 3, listItems);
                    const paginationNumbers = document.getElementsByClassName("pagination-numbers")[index];
                    getMobilePagination(pageCount, 1, paginationNumbers, listItems);
                });
            }
        }

        //$.makeResidentialPager();

    });
})(jQuery);
